module.exports = __webpack_public_path__ + "img/xiangying@2x.b54e0acf.png";